<template>
  <v-row>
    <v-col cols="12">
      <v-data-table :headers="headers" :items="items" @click:row="onClickRow">
        <template v-slot:top>
          <v-toolbar flat>
            <v-spacer></v-spacer>
            <v-btn color="success" dark rounded @click="openCreateBank">
              <v-icon>
                mdi-plus
              </v-icon>
            </v-btn>
          </v-toolbar>
        </template>
        <template v-slot:item.no="{ item }">
          {{ items.findIndex(x => x === item) + 1 }}
        </template>
        <template v-slot:no-data>
          <v-btn color="primary" @click="initialize">
            Reset
          </v-btn>
        </template>
      </v-data-table>
    </v-col>

    <DialogFormBankExternal
      :dialog="dialogCreate"
      :title="title"
      :form="form"
      @close="close"
      @save="save"
    />
  </v-row>
</template>

<script>
import DialogFormBankExternal from "./DialogFormBankExternal.vue";

export default {
  name: "bank-external",
  components: {
    DialogFormBankExternal,
  },
  data: () => ({
    dialogCreate: false,
    dialogUpdate: false,
    form: {},
    defaultForm: {
      name: "",
      code: "",
      swiftCode: "",
    },
    items: [],
    title: "Create",
    headers: [
      {
        text: "No",
        align: "start",
        sortable: false,
        value: "no",
      },
      { text: "Name", value: "name", sortable: false },
      { text: "Code", value: "code", sortable: false },
      { text: "Swift Code", value: "swiftCode", sortable: false },
    ],
  }),

  created() {
    this.initialize();
  },

  methods: {
    async initialize() {
      this.$store.commit("SET_LOADER", true);
      await this.$store
        .dispatch("bank/getExternals")
        .then(response => {
          this.items = response.data;
          this.$store.commit("SET_LOADER", false);
        })
        .catch(() => {
          this.$store.dispatch("toast", {
            type: "error",
            message: "Ada masalah dengan aplikasi, mohon hubungi admin aplikasi",
          });
          this.$store.commit("SET_LOADER", false);
        });
    },
    onClickRow(item) {
      this.title = "Update";
      Object.assign(this.form, item);
      this.dialogCreate = true;
    },
    openCreateBank() {
      this.title = "Create";
      this.dialogCreate = true;
      Object.assign(this.form, this.defaultForm);
    },
    close() {
      this.dialogCreate = false;
    },
    save() {
      this.$store.commit("SET_LOADER", true);
      this.$store
        .dispatch("bank/saveBankExternal", this.form)
        .then(() => {
          this.$store.commit("SET_LOADER", false);
          this.initialize();
          this.close();
        })
        .catch(() => {
          this.$store.dispatch("toast", {
            type: "error",
            message: "Ada masalah dengan aplikasi, mohon hubungi admin aplikasi",
          });
          this.$store.commit("SET_LOADER", false);
        });
    },
  },
  mounted() {
    this.initialize();
  },
};
</script>

<style></style>
